import React from "react";

export default props => {
  return (
    <div>
      <section className="section-heading row">CHOOSE YOUR BOTTLE</section>
      <section id="bottles" className="row">
        {/*} <div onClick={props.selectBottles.bind(this,'classic')} className="classic col-sm-4">
    <div style={{backgroundSize: 'contain', backgroundImage: `url(https://cdn.shopify.com/s/files/1/1173/0620/files/classic-28oz-${props.color}.png)`}} className="size28oz"></div>
    {/*<div style={{backgroundSize: 'contain', backgroundImage: `url(/bottles/classic-20oz-${props.color}.png)`}} className="size20oz"></div>*/}
        {/*</div>*/}
        <div
          onClick={props.selectBottles.bind(this, "sportMixer")}
          className="sportmixer col-sm-4 col-sm-offset-4"
        >
          <div
            style={{
              backgroundSize: "contain",
              backgroundImage: `url(https://cdn.shopify.com/s/files/1/1173/0620/files/sportMixer-28oz-${props.color}.png)`
            }}
            className="size28oz"
          />
          {/*<div style={{backgroundSize: 'contain', backgroundImage: `url(/bottles/sportMixer-20oz-${props.color}.png)`}} className="size20oz"></div>*/}
        </div>
      </section>
      <section className="row bottle-labels">
        {/*<div className="text-center bottle-label col-sm-4">Classic<sup>™</sup></div>*/}

        <div className="text-center bottle-label col-sm-4 col-sm-offset-4">
          SportMixer<sup>®</sup>
        </div>
      </section>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/ChooseBottle.jsx